
import { useState, FormEvent } from 'react';

const NewsletterComunidade = () => {
  const [email, setEmail] = useState('');
  const [nome, setNome] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!email || !nome) return;

    setStatus('loading');
    try {
      const formData = new URLSearchParams();
      formData.append('nome', nome);
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d6cukh2ohb161tfd890g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      if (response.ok) {
        setStatus('success');
        setEmail('');
        setNome('');
        setTimeout(() => setStatus('idle'), 4000);
      } else {
        setStatus('error');
        setTimeout(() => setStatus('idle'), 3000);
      }
    } catch {
      setStatus('error');
      setTimeout(() => setStatus('idle'), 3000);
    }
  };

  return (
    <section className="relative py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/be5825de11d189c6aa58777c332ad753.jpg"
          alt="Ambiente luxuoso para escrita"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/75 to-black/85"></div>
      </div>

      <div className="container mx-auto px-6 lg:px-16 relative z-10">
        <div className="max-w-2xl mx-auto text-center">
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="w-12 h-px bg-gold-500/40"></div>
            <span className="font-['Montserrat'] text-xs tracking-[0.3em] uppercase text-gold-400">
              Fique por dentro
            </span>
            <div className="w-12 h-px bg-gold-500/40"></div>
          </div>

          <h2 className="font-['Playfair_Display'] text-4xl lg:text-5xl text-white mb-4">
            Junte-se à comunidade
          </h2>
          <p className="font-['Montserrat'] text-sm text-white/40 mb-10 font-light tracking-wide max-w-md mx-auto">
            Receba histórias inspiradoras, dicas de escrita e novidades exclusivas da nossa comunidade
          </p>

          <form
            id="newsletter-comunidade-form"
            data-readdy-form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-xl mx-auto"
          >
            <input
              type="text"
              name="nome"
              placeholder="Seu nome"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              required
              className="flex-1 bg-white/[0.06] border border-gold-500/15 rounded-lg px-5 py-3.5 font-['Montserrat'] text-sm text-white placeholder:text-white/25 focus:outline-none focus:border-gold-500/40 transition-colors"
            />
            <input
              type="email"
              name="email"
              placeholder="Seu melhor email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="flex-1 bg-white/[0.06] border border-gold-500/15 rounded-lg px-5 py-3.5 font-['Montserrat'] text-sm text-white placeholder:text-white/25 focus:outline-none focus:border-gold-500/40 transition-colors"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="bg-gradient-to-r from-gold-500 to-gold-600 text-luxury-black font-['Montserrat'] font-semibold text-xs px-8 py-3.5 rounded-lg hover:shadow-[0_0_20px_rgba(201,168,76,0.25)] transition-all duration-300 whitespace-nowrap cursor-pointer tracking-wider uppercase disabled:opacity-50"
            >
              {status === 'loading' ? (
                <span className="flex items-center gap-2">
                  <i className="ri-loader-4-line animate-spin text-sm"></i>
                  Enviando
                </span>
              ) : (
                'Participar'
              )}
            </button>
          </form>

          {status === 'success' && (
            <div className="mt-4 flex items-center justify-center gap-2">
              <i className="ri-check-double-line text-emerald-400 text-sm"></i>
              <p className="font-['Montserrat'] text-xs text-emerald-400 tracking-wide">
                Bem-vindo(a) à comunidade! Verifique seu email.
              </p>
            </div>
          )}

          {status === 'error' && (
            <div className="mt-4 flex items-center justify-center gap-2">
              <i className="ri-error-warning-line text-rose-400 text-sm"></i>
              <p className="font-['Montserrat'] text-xs text-rose-400 tracking-wide">
                Algo deu errado. Tente novamente.
              </p>
            </div>
          )}

          <p className="font-['Montserrat'] text-[10px] text-white/20 mt-5 tracking-wide">
            Sem spam. Você pode cancelar a qualquer momento.
          </p>
        </div>
      </div>
    </section>
  );
};

export default NewsletterComunidade;
